define('responsive-gameday/helpers/GamePanelViewConfig',['require','exports','module','../controllers/GameStateViewController','../controllers/LiveViewController','../controllers/WrapupViewController','../controllers/PregameViewController','../controllers/PregameMatchupViewController','../controllers/LineupViewController','../controllers/BoxscoreViewController','../controllers/PlayByPlayViewController','../controllers/VideosViewController','../controllers/FieldViewController','../controllers/ColorViewController'],function(require,exports,module) {
    var GameStateViewController = require("../controllers/GameStateViewController"),
    	LiveViewController = require( '../controllers/LiveViewController' ),
    	WrapupViewController = require( '../controllers/WrapupViewController' ),
    	PregameViewController = require( '../controllers/PregameViewController' ),
    	PregameMatchupViewController = require( '../controllers/PregameMatchupViewController' ),
    	LineupViewController = require( '../controllers/LineupViewController' ),
        BoxscoreViewController = require("../controllers/BoxscoreViewController"),
        PlayByPlayViewController = require("../controllers/PlayByPlayViewController"),
        VideosViewController = require("../controllers/VideosViewController"),
        FieldViewController = require("../controllers/FieldViewController"),
        ColorViewController = require("../controllers/ColorViewController");

       
	var _config={
		full : {
			pregame : [{
				id 		: "preview",
				args 	: 'preview',
				name    : "Preview",
				name_es : "Previo",
				live 	: true,
				viewController : "PregameViewController"
			},{
				args 	: 'lineups',
				id 		: 'lineups',
				name    : "Lineups",
				name_es	: "Alineaci&#243;n",
				viewController : LineupViewController
			},{
				args 	: 'matchups',
				id 		: 'matchups',
				name    : "Matchups",
				name_es : "Enfrentamiento",
				viewController : PregameMatchupViewController
			}
			]
		}
	};

	_config.full._default_=_config.full.pregame;

	_config.full.live = [{
			id 				: "game",
			name            : 'Live',
			name_es			: 'Vivo',
			live 			: true,
			viewController  : LiveViewController
		},{
			id 		: "boxscore",
			name    : "Box",
			name_es : "Box",
			viewController : BoxscoreViewController
		},{
			id 		: "plays",
			name    : "Plays",
			name_es : "Jugadas",
			args 	: "single",
			viewController : PlayByPlayViewController
		},{
			id 		: "videos",
			name    : "Video",
			viewController : VideosViewController
		},{
			id      : "field",
			name    : "Field",
			name_es : "Campo",
			viewController : FieldViewController
		},{
                        id      : "color",
            name    : "Feed",
            name_es : "Feed",
                        viewController : ColorViewController
                }];

	_config.full.wrapup=[{
		id 				: "wrap",
		name            : 'Wrap',
		name_es			: "Resumen",
		live 			: true,
		viewController  : WrapupViewController
	}];

    _config.full.wrapup.push.apply(_config.full.wrapup,_config.full.live.slice(1));

	_config.lite = {
		pregame   : _config.full.pregame,
		_default_ : [
		{
			id 				: "game",
			name            : 'Live',
			name_es			: 'Vivo',
			live 			: true,
			viewController  : LiveViewController
		},{
			name    : "Box",
			id 		: "boxscore",
			viewController : BoxscoreViewController
		},{
			id 		: "plays",
			name    : "Plays",
			name_es : "Jugadas",
			args 	: "single",
			viewController : PlayByPlayViewController
		},{
			id      : "field",
			name    : "Field",
			name_es : "Campo",
			viewController : FieldViewController
		}],
		wrapup   : [
		{
			id 				: "wrap",
			name            : 'Wrap',
			name_es			: "Resumen",
			live 			: true,
			viewController  : WrapupViewController
		},{
			name    : "Box",
			id 		: "boxscore",
			viewController : BoxscoreViewController
		},{
			id 		: "plays",
			name    : "Plays",
			name_es : "Jugadas",
			args 	: "single",
			viewController : PlayByPlayViewController
		}]
	};

	return function (type,state){
		var setType=_config[type]||_config.full;

		return setType[state.toLowerCase()] || setType._default_;

	};
});

